/* @ngInject */
const myDispatchEditForm = () => {
  return {
    restrict: 'E',
    scope: {
      myDispatch: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myDispatchEditForm.html'),

    /* @ngInject */
    controller: ($scope, $$dispatch) => {
      $scope.updateDispatch = (_dispatch) => {
        $$dispatch.ask.update(_dispatch, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDispatchEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/directives/forms/myDispatchEditForm.js